import { isEmpty } from 'lodash-es'

export const isEmptyOrWhitespace = (value) => {
  return isEmpty(value) || (typeof value === 'string' && value.trim() === '')
}
